import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './form.scss';

function Form({ formHandler, parentClasses, children }) {
    const formClasses = `form ${parentClasses}`;
    return (
        <form className={formClasses} onSubmit={formHandler}>
            {children}
        </form>
    );
}

Form.propTypes = {
    formHandler: PropTypes.func,
    parentClasses: PropTypes.string,
    children: PropTypes.any
};

export default Form;



// WEBPACK FOOTER //
// ./components/form/form.js